// IND-026: cabecera ordenable común de Control de planta, con el patrón del
// Panel: flecha siempre visible junto al título y solo la columna activa
// resaltada en azul.
import type { ReactNode } from 'react';
import { TableCell, TableSortLabel } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

import type { SortDirection, TableSort } from '../utils/tableSort';

const ACTIVE = '#38bdf8';

// Tablas con más de 10 filas: 10 visibles y scroll interno (cabecera fija).
// Cabecera ≈ 38 px y fila pequeña de una línea ≈ 34 px.
export const TEN_ROWS_MAX_HEIGHT = 38 + 34 * 10;

type Props<K extends string> = {
  label: ReactNode;
  columnKey: K;
  sort: TableSort<K>;
  align?: 'left' | 'right' | 'center';
  /** Sentido al pulsarla por primera vez: textos y fechas ascendente, cifras descendente. */
  firstDirection?: SortDirection;
  sx?: SxProps<Theme>;
};

export default function SortableHeaderCell<K extends string>({
  label,
  columnKey,
  sort,
  align,
  firstDirection = 'desc',
  sx,
}: Props<K>) {
  const active = sort.key === columnKey;
  return (
    <TableCell align={align} sortDirection={active ? sort.direction : false} sx={sx}>
      <TableSortLabel
        active={active}
        direction={active ? sort.direction : firstDirection}
        onClick={() => sort.toggle(columnKey, firstDirection)}
        sx={{
          color: active ? `${ACTIVE} !important` : 'inherit',
          fontWeight: active ? 800 : undefined,
          '&:hover': { color: active ? undefined : '#e2e8f0' },
          '& .MuiTableSortLabel-icon': {
            opacity: '1 !important',
            color: active ? `${ACTIVE} !important` : '#64748b !important',
          },
        }}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );
}
